import { SimplePaletteColorOptions, ThemeOptions } from '@mui/material';
import { colors } from '@sensei/pi-component';

export const MuiFab = (theme: ThemeOptions) => {
    return {
        styleOverrides: {
            root: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                border: `1px solid ${
                    (theme.palette?.primary as SimplePaletteColorOptions)
                        .main || colors.CARBON
                }`,
            },
            primary: {
                backgroundColor: 'transparent',
                border: `1px solid ${
                    (theme.palette?.secondary as SimplePaletteColorOptions)
                        .main || colors.CARBON
                }`,
            },
        },
    };
};
